var React = require('react');

function ErrorX (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("g",{"id":"login","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"sign-up---wrong-format","transform":"translate(-32.000000, -408.000000)","stroke":"#BB0104"},React.createElement("g",{"id":"x_icn-copy-2","transform":"translate(33.000000, 408.000000)"},[React.createElement("path",{"d":"M0,0 L7.73333333,7.73333333","id":"Stroke-1","key":0}),React.createElement("path",{"d":"M0,7.73333333 L7.73333333,0","id":"Stroke-3","key":1})])))]);
}

ErrorX.defaultProps = {"width":"10px","height":"8px","viewBox":"0 0 10 8","version":"1.1"};

module.exports = ErrorX;

ErrorX.default = ErrorX;
